var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0830078 21.9677C0.0830078 21.4721 0.484803 21.0703 0.980443 21.0703H22.5189C23.0145 21.0703 23.4163 21.4721 23.4163 21.9677C23.4163 22.4634 23.0145 22.8652 22.5189 22.8652H0.980443C0.484803 22.8652 0.0830078 22.4634 0.0830078 21.9677Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21166 12.0996C4.11254 12.0996 4.03218 12.1799 4.03218 12.279V20.8944C4.03218 20.9936 4.11254 21.0739 4.21166 21.0739H8.51936C8.61848 21.0739 8.69884 20.9936 8.69884 20.8944V12.279C8.69884 12.1799 8.61848 12.0996 8.51936 12.0996H4.21166ZM2.2373 12.279C2.2373 11.1886 3.12126 10.3047 4.21166 10.3047H8.51936C9.60977 10.3047 10.4937 11.1886 10.4937 12.279V20.8944C10.4937 21.9848 9.60977 22.8688 8.51936 22.8688H4.21166C3.12126 22.8688 2.2373 21.9848 2.2373 20.8944V12.279Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6716 2.40425C10.5725 2.40425 10.4921 2.48461 10.4921 2.58373V20.8914C10.4921 20.9905 10.5725 21.0709 10.6716 21.0709H19.287C19.3861 21.0709 19.4665 20.9905 19.4665 20.8914V2.58373C19.4665 2.48461 19.3861 2.40425 19.287 2.40425H10.6716ZM8.69727 2.58373C8.69727 1.49333 9.58122 0.609375 10.6716 0.609375H19.287C20.3774 0.609375 21.2614 1.49333 21.2614 2.58373V20.8914C21.2614 21.9818 20.3774 22.8658 19.287 22.8658H10.6716C9.58122 22.8658 8.69727 21.9818 8.69727 20.8914V2.58373Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.006 6.89744C13.006 6.4018 13.4078 6 13.9034 6H16.0573C16.5529 6 16.9547 6.4018 16.9547 6.89744C16.9547 7.39308 16.5529 7.79487 16.0573 7.79487H13.9034C13.4078 7.79487 13.006 7.39308 13.006 6.89744ZM13.006 11.7436C13.006 11.2479 13.4078 10.8462 13.9034 10.8462H16.0573C16.5529 10.8462 16.9547 11.2479 16.9547 11.7436C16.9547 12.2392 16.5529 12.641 16.0573 12.641H13.9034C13.4078 12.641 13.006 12.2392 13.006 11.7436ZM4.39062 16.5897C4.39062 16.0941 4.79242 15.6923 5.28806 15.6923H7.44191C7.93755 15.6923 8.33934 16.0941 8.33934 16.5897C8.33934 17.0854 7.93755 17.4872 7.44191 17.4872H5.28806C4.79242 17.4872 4.39062 17.0854 4.39062 16.5897ZM13.006 16.5897C13.006 16.0941 13.4078 15.6923 13.9034 15.6923H16.0573C16.5529 15.6923 16.9547 16.0941 16.9547 16.5897C16.9547 17.0854 16.5529 17.4872 16.0573 17.4872H13.9034C13.4078 17.4872 13.006 17.0854 13.006 16.5897Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/City.ae9e4f14600f31dc57957739a4c11bff.svg";
export { ForwardRef as ReactComponent };